<tt-page>
    <ng-container *ngIf="!tabletSize.matches">
        <tt-card class="col-xs-12 col-md-4 sp-0">
            <tt-button ttText="create_new_shift" ttIcon="fas fa-plus" ttTextAlign="left" ttIconPullRight ttGoto="shift" [ttGotoParms]="{ shift_id: '0' }"></tt-button>
            <tt-list [ttData]="shifts"></tt-list>
        </tt-card>
    </ng-container>
    <ng-container *ngIf="tabletSize.matches">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-page-heading ttModel="h_shifts" ttTranslate></tt-page-heading>
            <tt-button ttText="create_new_shift" ttIcon="fas fa-plus" ttTextAlign="left" ttIconPullRight (ttClick)="createShift()"></tt-button>
            <tt-list [ttData]="shifts" [ttGoto]="false" (ttClick)="openShift($event.item)"></tt-list>
        </tt-card>
        <div *ngIf="shiftId" class="col-xs-12 col-md-9 p-0">
            <tt-shift [shiftId]="shiftId" (onSave)="updateShifts()" (onDelete)="updateShifts()"></tt-shift>
        </div>
    </ng-container>
</tt-page>
